/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type IdCardType = "license" | "state_id" | "unknown" | "%future added value";
export type PersonEyeColor = "black" | "blue" | "brown" | "gray" | "green" | "hazel" | "maroon" | "unknown" | "%future added value";
export type PersonHair = "bald" | "black" | "blonde" | "blue" | "brown" | "gray" | "green" | "orange" | "pink" | "purple" | "red" | "sandy" | "unknown" | "white" | "%future added value";
export type PersonRace = "AmericanIndianOrAlaskaNative" | "Asian" | "BlackOrAfricanAmerican" | "NativeHawaiianOrOtherPacificIslander" | "Unknown" | "White" | "%future added value";
export type PersonSex = "female" | "male" | "unknown" | "%future added value";
export type SmsMessageActor = "promise" | "twilio" | "%future added value";
export type ParticipantDetailsQueryTypesQueryVariables = {
    readonly id: string;
};
export type ParticipantDetailsQueryTypesQueryResponse = {
    readonly application: ({
        readonly compliance_options: ReadonlyArray<({
            readonly key: string;
            readonly value: string | null;
        }) | null> | null;
        readonly risk_levels: ReadonlyArray<({
            readonly key: string;
            readonly value: string | null;
        }) | null> | null;
        readonly twilio: ({
            readonly source_number: string | null;
        }) | null;
    }) | null;
    readonly participants: ({
        readonly participant: ReadonlyArray<({
            readonly id: string;
            readonly created_at: string;
            readonly auth_token: string | null;
            readonly case_manager: ({
                readonly id: string;
                readonly name: {
                    readonly first: string;
                    readonly last: string | null;
                };
            }) | null;
            readonly language: string;
            readonly name: {
                readonly first: string;
                readonly last: string | null;
            };
            readonly preferred_name: string | null;
            readonly assessment: ({
                readonly score: string | null;
                readonly tool: string | null;
            }) | null;
            readonly phone: ({
                readonly mobile: string | null;
                readonly home: string | null;
            }) | null;
            readonly risk_level: string | null;
            readonly status: string | null;
            readonly compliance: string | null;
            readonly sms_enabled: boolean | null;
            readonly sms_disabled_by: SmsMessageActor | null;
            readonly sms_consent: boolean | null;
            readonly sms_can_enable: boolean | null;
            readonly is_active: boolean | null;
            readonly supervision_begin_date: string | null;
            readonly supervision_end_date: string | null;
            readonly address: ({
                readonly value: string | null;
            }) | null;
            readonly hispanic_or_latino: boolean | null;
            readonly race: PersonRace | null;
            readonly alcohol_monitoring: boolean | null;
            readonly gps_monitoring: boolean | null;
            readonly date_of_birth: string | null;
            readonly sex: PersonSex | null;
            readonly employer: ({
                readonly name: string | null;
            }) | null;
            readonly hair: PersonHair | null;
            readonly eye_color: PersonEyeColor | null;
            readonly height: string | null;
            readonly weight: string | null;
            readonly person_address: string | null;
            readonly place_of_birth: string | null;
            readonly person_id: ({
                readonly number: string | null;
                readonly state: string | null;
                readonly type: IdCardType | null;
            }) | null;
            readonly victims: ReadonlyArray<{
                readonly name: ({
                    readonly first: string | null;
                    readonly last: string | null;
                }) | null;
                readonly phone: string | null;
                readonly date_of_birth: string | null;
                readonly address: string | null;
                readonly sex: PersonSex | null;
            }> | null;
            readonly stay_away: boolean | null;
            readonly peaceful_contact: boolean | null;
            readonly case_number: string | null;
            readonly case_numbers: ReadonlyArray<string | null> | null;
            readonly extra_equipment: string | null;
            readonly incident_notes: string | null;
            readonly offense_info: string | null;
            readonly supervised_probation: boolean | null;
            readonly probation_officer: string | null;
            readonly current_device: ({
                readonly platform: string | null;
            }) | null;
            readonly profile_image: ({
                readonly base64_media: string | null;
                readonly mime_type: string | null;
            }) | null;
            readonly fines_and_fees: ({
                readonly fines_and_fees_amount_owed: number | null;
                readonly fines_and_fees_last_payment_amount: number | null;
                readonly fines_and_fees_last_payment_date: string | null;
                readonly fines_and_fees_expected_payment_amount: number | null;
                readonly restitution_amount_owed: number | null;
                readonly restitution_last_payment_amount: number | null;
                readonly restitution_last_payment_date: string | null;
                readonly restitution_expected_payment_amount: number | null;
            }) | null;
            readonly record_source: string | null;
            readonly court_recommendation: string | null;
            readonly court_decision: string | null;
            readonly case_disposition: string | null;
            readonly home_phone_human_readable: string | null;
            readonly cell_phone_human_readable: string | null;
            readonly equipment_returned: ReadonlyArray<string | null> | null;
            readonly protective_order_notes: string | null;
            readonly probation_number: string | null;
        }) | null> | null;
    }) | null;
};
export type ParticipantDetailsQueryTypesQuery = {
    readonly response: ParticipantDetailsQueryTypesQueryResponse;
    readonly variables: ParticipantDetailsQueryTypesQueryVariables;
};



/*
query ParticipantDetailsQueryTypesQuery(
  $id: String!
) {
  application {
    compliance_options {
      key
      value
    }
    risk_levels {
      key
      value
    }
    twilio {
      source_number
    }
    id
  }
  participants(id: $id) {
    participant {
      id
      created_at
      auth_token
      case_manager {
        id
        name {
          first
          last
        }
      }
      language
      name {
        first
        last
      }
      preferred_name
      assessment {
        score
        tool
      }
      phone {
        mobile
        home
      }
      risk_level
      status
      compliance
      sms_enabled
      sms_disabled_by
      sms_consent
      sms_can_enable
      is_active
      supervision_begin_date
      supervision_end_date
      address {
        value
      }
      hispanic_or_latino
      race
      alcohol_monitoring
      gps_monitoring
      date_of_birth
      sex
      employer {
        name
      }
      hair
      eye_color
      height
      weight
      person_address
      place_of_birth
      person_id {
        number
        state
        type
      }
      victims {
        name {
          first
          last
        }
        phone
        date_of_birth
        address
        sex
      }
      stay_away
      peaceful_contact
      case_number
      case_numbers
      extra_equipment
      incident_notes
      offense_info
      supervised_probation
      probation_officer
      current_device {
        platform
      }
      profile_image {
        base64_media
        mime_type
      }
      fines_and_fees {
        fines_and_fees_amount_owed
        fines_and_fees_last_payment_amount
        fines_and_fees_last_payment_date
        fines_and_fees_expected_payment_amount
        restitution_amount_owed
        restitution_last_payment_amount
        restitution_last_payment_date
        restitution_expected_payment_amount
      }
      record_source
      court_recommendation
      court_decision
      case_disposition
      home_phone_human_readable
      cell_phone_human_readable
      equipment_returned
      protective_order_notes
      probation_number
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "id",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "value",
        "args": null,
        "storageKey": null
    } as any), v2 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "key",
            "args": null,
            "storageKey": null
        } as any),
        (v1 /*: any*/)
    ], v3 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "compliance_options",
        "storageKey": null,
        "args": null,
        "concreteType": "KeyedString",
        "plural": true,
        "selections": (v2 /*: any*/)
    } as any), v4 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "risk_levels",
        "storageKey": null,
        "args": null,
        "concreteType": "KeyedString",
        "plural": true,
        "selections": (v2 /*: any*/)
    } as any), v5 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "twilio",
        "storageKey": null,
        "args": null,
        "concreteType": "TwilioConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "source_number",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v7 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "first",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "last",
            "args": null,
            "storageKey": null
        } as any)
    ], v8 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "name",
        "storageKey": null,
        "args": null,
        "concreteType": "PersonName",
        "plural": false,
        "selections": (v7 /*: any*/)
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "date_of_birth",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "sex",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "participants",
        "storageKey": null,
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
            }
        ],
        "concreteType": "Pagination",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "participant",
                "storageKey": null,
                "args": null,
                "concreteType": "Participant",
                "plural": true,
                "selections": [
                    (v6 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "created_at",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "auth_token",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "case_manager",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CaseManager",
                        "plural": false,
                        "selections": [
                            (v6 /*: any*/),
                            (v8 /*: any*/)
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "language",
                        "args": null,
                        "storageKey": null
                    },
                    (v8 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "preferred_name",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "assessment",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ParticipantAssessment",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "score",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "tool",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "phone",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PersonPhone",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "mobile",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "home",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "risk_level",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "status",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "compliance",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "sms_enabled",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "sms_disabled_by",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "sms_consent",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "sms_can_enable",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "is_active",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "supervision_begin_date",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "supervision_end_date",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "address",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VerifiedAddress",
                        "plural": false,
                        "selections": [
                            (v1 /*: any*/)
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hispanic_or_latino",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "race",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "alcohol_monitoring",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "gps_monitoring",
                        "args": null,
                        "storageKey": null
                    },
                    (v9 /*: any*/),
                    (v10 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "employer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ParticipantEmployer",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "name",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hair",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "eye_color",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "height",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "weight",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "person_address",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "place_of_birth",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "person_id",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PersonId",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "number",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "state",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "type",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "victims",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ParticipantContact",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "name",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "VictimName",
                                "plural": false,
                                "selections": (v7 /*: any*/)
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "phone",
                                "args": null,
                                "storageKey": null
                            },
                            (v9 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "address",
                                "args": null,
                                "storageKey": null
                            },
                            (v10 /*: any*/)
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "stay_away",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "peaceful_contact",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case_number",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case_numbers",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "extra_equipment",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "incident_notes",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "offense_info",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "supervised_probation",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "probation_officer",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "current_device",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ParticipantMobileDevice",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "platform",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "profile_image",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PersonImage",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "base64_media",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "mime_type",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "fines_and_fees",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinesAndFees",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "fines_and_fees_amount_owed",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "fines_and_fees_last_payment_amount",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "fines_and_fees_last_payment_date",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "fines_and_fees_expected_payment_amount",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "restitution_amount_owed",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "restitution_last_payment_amount",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "restitution_last_payment_date",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "restitution_expected_payment_amount",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "record_source",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "court_recommendation",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "court_decision",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case_disposition",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "home_phone_human_readable",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cell_phone_human_readable",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "equipment_returned",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "protective_order_notes",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "probation_number",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ParticipantDetailsQueryTypesQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "application",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Application",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        (v5 /*: any*/)
                    ]
                },
                (v11 /*: any*/)
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "ParticipantDetailsQueryTypesQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "application",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Application",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        (v5 /*: any*/),
                        (v6 /*: any*/)
                    ]
                },
                (v11 /*: any*/)
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "ParticipantDetailsQueryTypesQuery",
            "id": null,
            "text": "query ParticipantDetailsQueryTypesQuery(\n  $id: String!\n) {\n  application {\n    compliance_options {\n      key\n      value\n    }\n    risk_levels {\n      key\n      value\n    }\n    twilio {\n      source_number\n    }\n    id\n  }\n  participants(id: $id) {\n    participant {\n      id\n      created_at\n      auth_token\n      case_manager {\n        id\n        name {\n          first\n          last\n        }\n      }\n      language\n      name {\n        first\n        last\n      }\n      preferred_name\n      assessment {\n        score\n        tool\n      }\n      phone {\n        mobile\n        home\n      }\n      risk_level\n      status\n      compliance\n      sms_enabled\n      sms_disabled_by\n      sms_consent\n      sms_can_enable\n      is_active\n      supervision_begin_date\n      supervision_end_date\n      address {\n        value\n      }\n      hispanic_or_latino\n      race\n      alcohol_monitoring\n      gps_monitoring\n      date_of_birth\n      sex\n      employer {\n        name\n      }\n      hair\n      eye_color\n      height\n      weight\n      person_address\n      place_of_birth\n      person_id {\n        number\n        state\n        type\n      }\n      victims {\n        name {\n          first\n          last\n        }\n        phone\n        date_of_birth\n        address\n        sex\n      }\n      stay_away\n      peaceful_contact\n      case_number\n      case_numbers\n      extra_equipment\n      incident_notes\n      offense_info\n      supervised_probation\n      probation_officer\n      current_device {\n        platform\n      }\n      profile_image {\n        base64_media\n        mime_type\n      }\n      fines_and_fees {\n        fines_and_fees_amount_owed\n        fines_and_fees_last_payment_amount\n        fines_and_fees_last_payment_date\n        fines_and_fees_expected_payment_amount\n        restitution_amount_owed\n        restitution_last_payment_amount\n        restitution_last_payment_date\n        restitution_expected_payment_amount\n      }\n      record_source\n      court_recommendation\n      court_decision\n      case_disposition\n      home_phone_human_readable\n      cell_phone_human_readable\n      equipment_returned\n      protective_order_notes\n      probation_number\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'b7dc2cd88abaa557cebbd72d77e61935';
export default node;
